"use client";

import ModelMark from "@/components/chat/ModelMark";
import {Combobox} from "@/components/ui/combobox";
import {useModelOptionsGrouped} from "@/hooks/useModelOptions";
import {isAutoSelectableForConversation} from "@/services/wingman";
import {getModelDisplayName} from "@/utils/ai/assistants";

interface ChannelModelComboboxProps {
   currentModel: string;
   onChange?: (model: string) => void;
   disabled?: boolean;
   placeholder?: string;
   emptyMessage?: string;
   triggerClassName?: string;
   contentClassName?: string;
   readOnly?: boolean;
   readOnlyClassName?: string;
   conversationId?: string | null;
}

export function ChannelModelCombobox({
   currentModel,
   onChange,
   disabled,
   placeholder,
   emptyMessage,
   triggerClassName = "w-full mb-2 justify-between",
   contentClassName = "w-[var(--radix-popover-trigger-width)] bg-panel focus:ring-0",
   readOnly = false,
   readOnlyClassName,
   conversationId,
}: Readonly<ChannelModelComboboxProps>) {
   const modelGroups = useModelOptionsGrouped(currentModel, {
      allowAuto: isAutoSelectableForConversation(conversationId),
   });

   if (readOnly) {
      const displayName = getModelDisplayName(currentModel);

      return (
         <span className={readOnlyClassName}>
            <ModelMark model={currentModel} className="text-[10px] shrink-0" />
            <span className="truncate">{displayName}</span>
         </span>
      );
   }

   return (
      <Combobox
         groups={modelGroups}
         value={currentModel}
         onChange={onChange ?? (() => {})}
         triggerClassName={triggerClassName}
         contentClassName={contentClassName}
         placeholder={placeholder}
         emptyMessage={emptyMessage}
         disabled={disabled || !onChange}
      />
   );
}
